import { Flex } from "@chakra-ui/layout";
import { RTag } from "@components/Texts/Tag/Tag";
import { WidgetTitle } from "@components/Texts/WidgetTitle/WidgetTitle";
import { generateBlogTagUrl } from "@core/paths";
import { Link } from "@reach/router";
import React from "react";

export const CommonTags = ({ tags }) => (
    <>
        <WidgetTitle mb="23px">Częste tagi</WidgetTitle>
        <Flex flexWrap="wrap" justifyContent="flex-start">
            {tags.map(({ id, slug, name }) => (
                <RTag key={id} as={Link} to={generateBlogTagUrl(slug)}>{name}</RTag>
            ))}
        </Flex>
    </>
)
